import { createFileRoute } from '@tanstack/react-router';

import { AppointmentsComingSoonPage } from '@/features/appointments';

/** Coming soon (D-147): no guard, the `appointments.*` permissions are gone with the feature. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/appointments')({
  staticData: { crumb: 'common:nav.appointments' },
  component: AppointmentsComingSoonPage,
});
